var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SmartLink',{attrs:{"native":false,"to":"/account/point_logs"}},[_c('TopNavigationElement',{attrs:{"text":_vm.points,"additional-attrs":_vm.additionalAttrs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }